// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getWorkableBacklog(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/workable_backlog`);
}
